import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
  serviceCreateBrandMaster,
  serviceGetBrandMasterDetails,
  serviceUpdateBrandMaster,
} from "../../../services/BrandMaster.service";
import SnackbarUtils from "../../../libs/SnackbarUtils";
import historyUtils from "../../../libs/history.utils";
import RouteName from "../../../routes/Route.name";
import { useParams } from "react-router";
import { serviceGetList } from "../../../services/Common.service";
import {
  serviceIncentiveRulesList,
  serviceIncentiveRulesUpdate,
} from "../../../services/IncentiveRule.service";
import { useSelector } from "react-redux";
import LogUtils from "../../../libs/LogUtils";

const initialForm = {
  fy_year: "2025-26",
  quarter: "Q1",
  new_basket_target_min_percent: 75,
  max_achieved_families: 100,
  min_achieved_families: 100,
  categories: [],
  secondary_vs_primary_sales_ratio_min_percent: 60,
  incentive_cap: 10000,
  early_bird_target_met_value: 90,
  rupee_value_next_qtr_first_month_target_met_value: 0,
  rupee_value_min_product_criteria_met_value: 2000,
  product_next_qtr_first_month_target_met_value: 0,
  payment_collection_realized_value: 15000,
  mcl_coverage_value: 80,
  doctor_call_avg: 50,
  doctor_meeting_avg: 20,
  sales_withheld: 20,
  early_bird_subsequent_target_met_value: 0,
  tbm_achievement_prct: 100,
  manager_achievement_prct: 90,
  spi_other_achievement_prct: 0,
  spi_payout_rate: 0,
};

const useIncentiveRulesCreateHook = ({}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorData, setErrorData] = useState({});
  const [listData, setListData] = useState({
    PRODUCT_CATEGORIES: [],
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [form, setForm] = useState({ ...initialForm });
  const [isEdit, setIsEdit] = useState(false);
  const IncentiveRuleData = useSelector((state) => state.incentive_rules_form);

  useEffect(() => {
    if (IncentiveRuleData?.quarter && IncentiveRuleData?.quarter) {
      Promise.allSettled([
        serviceIncentiveRulesList({
          quarter: IncentiveRuleData?.quarter,
          fy_year: IncentiveRuleData?.fy_year,
        }),
        serviceGetList(["PRODUCT_CATEGORIES"]),
      ]).then((promises) => {
        const incData = promises[0]?.value?.data || {};
        const listData = promises[1]?.value?.data?.PRODUCT_CATEGORIES || [];
        const data = {};
        Object.keys({ ...initialForm })?.forEach((key) => {
          if (key !== "categories") {
            if (key === "quarter") {
              data[key] = incData[key] ?? IncentiveRuleData?.quarter;
            } else if (key === "fy_year") {
              data[key] = incData[key] ?? IncentiveRuleData?.fy_year;
            } else {
              data[key] = incData[key] || 0;
            }
          }
        });
        const merged = listData.map((item) => {
          const existing = incData?.categories?.find(
            (d) => d?.code === item?.code
          );
          return {
            category_id: item.id,
            name: item.name,
            code: item.code,
            rate: existing?.rate ?? 0,
            is_family_incentive: existing?.is_family_incentive ?? false,
            is_special_incentive: existing?.is_special_incentive ?? false,
          };
        });
        setForm({
          ...data,
          categories: [...merged],
        });
      });
    }
  }, []);

  const checkFormValidation = useCallback(() => {
    const errors = { ...errorData };
    let required = [
      "new_basket_target_min_percent",
      "max_achieved_families",
      "secondary_vs_primary_sales_ratio_min_percent",
      "incentive_cap",
      "early_bird_target_met_value",
      "rupee_value_next_qtr_first_month_target_met_value",
      "rupee_value_min_product_criteria_met_value",
      "product_next_qtr_first_month_target_met_value",
      "payment_collection_realized_value",
      "mcl_coverage_value",
      "doctor_call_avg",
      "doctor_meeting_avg",
      "early_bird_subsequent_target_met_value",
    ];
    required.forEach((val) => {
      if (
        form?.[val] === null ||
        form?.[val] === undefined ||
        form?.[val] === "" ||
        (Array.isArray(form?.[val]) && form?.[val].length === 0)
      ) {
        errors[val] = true;
      }
    });
    Object.keys(errors).forEach((key) => {
      if (!errors[key]) {
        delete errors[key];
      }
    });
    return errors;
  }, [form, errorData]);

  const submitToServer = useCallback(() => {
    if (!isSubmitting) {
      setIsSubmitting(true);
      let req = serviceIncentiveRulesUpdate;
      req({ ...form, categories: form?.categories?.map(({ name, ...rest }) => rest), }).then((res) => {
        if (!res.error) {
          SnackbarUtils.success("success")
          historyUtils.push(RouteName.INCENTIVE_RULES);
        } else {
          SnackbarUtils.error(res?.message);
        }
        setIsSubmitting(false);
      });
    }
  }, [form, isSubmitting, setIsSubmitting]);

  const handleSubmit = useCallback(async () => {
    const errors = checkFormValidation();
    if (Object.keys(errors).length > 0) {
      setErrorData(errors);
      return true;
    }
    submitToServer();
  }, [checkFormValidation, setErrorData, form]);

  console.log("form", form);
  const removeError = useCallback(
    (title) => {
      const temp = JSON.parse(JSON.stringify(errorData));
      temp[title] = false;
      setErrorData(temp);
    },
    [setErrorData, errorData]
  );

  const changeTextData = useCallback(
  (value, fieldName, index) => {
    const t = { ...form };

    if (typeof index === "number") {
      t.categories = [...form.categories];

      if (fieldName === "rate") {
  t.categories[index].rate = value;
} else if (fieldName === "is_family_incentive") {
  t.categories[index].is_family_incentive = value;
} else if (fieldName === "is_special_incentive") {
  t.categories[index].is_special_incentive = value;
}
    } else {
      t[fieldName] = value;
    }

    setForm(t);
    removeError(fieldName);
  },
  [form, removeError]
);

  const onBlurHandler = useCallback(
    (type) => {
      if (form?.[type]) {
        changeTextData(form?.[type].trim(), type);
      }
    },
    [changeTextData]
  );

  const handleDelete = useCallback(() => {}, []);

  const handleReset = useCallback(() => {
    setForm({ ...initialForm });
  }, [form]);
  LogUtils.log("form ??? ", form);

  return {
    form,
    changeTextData,
    onBlurHandler,
    removeError,
    handleSubmit,
    isLoading,
    isSubmitting,
    errorData,
    isEdit,
    handleDelete,
    handleReset,
  };
};

export default useIncentiveRulesCreateHook;
